import React from "react";
import { Empty } from "antd";
import styles from "./Landing.module.css";

// Trang chủ mới của portal. Trang Home cũ vẫn nằm ở src/pages/Home/Home.js
// (đã tháo khỏi router trong App.js) để dùng lại sau.
const Landing = () => {
  return (
    <div className={styles.pageContainer}>
      <div className={styles.placeholder}>
        <Empty description="Nội dung trang đang được xây dựng" />
      </div>
    </div>
  );
};

export default Landing;
